const headlines = [
  'Solutions Engineer', 2000,
  'Engineering Manager', 2000,
  'Staff Software Engineer', 2000,
  'Technical Mentor', 2000
]

export default headlines